export default __webpack_public_path__ + "static/media/1870.ff567eab.jpg";